import { handleErrors, URL } from "./depannageActions"
import { catchApiError, normalizeApiError } from "./apiHelpers"

// COUVERTURES D'ASSISTANCE (GE-60, backend/assistances/views_couvertures.py)
// — même contrat que assistancesActions : l'état vit dans les composants,
// chaque thunk résout avec le JSON, ou null en cas d'erreur (toast).
// `{ dansModal: true }` : pas de toast, résout `{ erreur }` pour l'afficher
// dans le modal ouvert (règle hybride, src/CLAUDE.md).
const requete =
	(method, chemin, body = null, opts = {}) =>
	async (dispatch, getState) => {
		const { token } = getState().navInfo.login
		if (!token) return null
		const multipart = body instanceof FormData
		return fetch(`${URL}api/assistances/${chemin}`, {
			method,
			headers: {
				Accept: "application/json, text/plain",
				...(multipart ? {} : { "Content-type": "application/json" }),
				Authorization: `Bearer ${token}`,
			},
			...(body ? { body: multipart ? body : JSON.stringify(body) } : {}),
		})
			.then(handleErrors)
			.then((res) => res.json())
			.catch(async (err) => {
				if (opts.dansModal)
					return { erreur: await normalizeApiError(err) }
				return catchApiError(dispatch, null, {
					silent: !!opts.silencieux,
				})(err).then(() => null)
			})
	}

const modal = { dansModal: true }

// Revue 08.10 (I9) : erreurs de lecture affichées (toast), plus muettes.
export const fetchCouverturesFiche = (depId) =>
	requete("get", `couvertures/fiche/${depId}`)
export const fetchCouverturesMission = (missionId) =>
	requete("get", `couvertures/mission/${missionId}`)
export const fetchResumeCouvertures = (ids) =>
	requete("get", `couvertures/resume-missions?ids=${ids.join(",")}`, null, {
		silencieux: true,
	})
export const fetchReferencesCouverture = (ref, { fiche, mission } = {}) =>
	requete(
		"get",
		`couvertures/references?ref=${encodeURIComponent(ref)}${
			fiche ? `&fiche=${fiche}` : ""
		}${mission ? `&mission=${mission}` : ""}`,
		null,
		{ silencieux: true },
	)
// `pour` : "mission:<id>" | "couverture:<id>" ; filtres : {q, appel, periode, etat}.
export const fetchCandidatsCouverture = (pour, filtres = {}) => {
	const params = new URLSearchParams({ pour })
	Object.entries(filtres).forEach(([k, v]) => {
		if (v !== null && v !== undefined && v !== "") params.set(k, v)
	})
	return requete("get", `couvertures/candidats?${params.toString()}`)
}

export const creerCouverture = (data) =>
	requete("post", "couvertures", data, modal)
export const modifierCouverture = (id, data) =>
	requete("put", `couvertures/${id}`, data, modal)
export const statutCouverture = (id, action, motif = "") =>
	requete("post", `couvertures/${id}/statut`, { action, motif }, modal)
export const encaisserCouverture = (id, data) =>
	requete("post", `couvertures/${id}/encaisser`, data, modal)
export const envoyerJustificatif = (id, fichier) => {
	const form = new FormData()
	form.append("fichier", fichier)
	return requete("post", `couvertures/${id}/justificatif`, form, modal)
}

// Requalifications (§5) : `simuler: true` → plan (aperçu, refus, base) ;
// application avec la `base` vue (409 si la situation a changé).
export const deplacerCouverture = (id, body) =>
	requete("post", `couvertures/${id}/deplacer`, body, modal)
export const couvertureVersMission = (id, body) =>
	requete("post", `couvertures/${id}/nouvelle-intervention`, body, modal)
export const missionVersCouverture = (missionId, body) =>
	requete("post", `missions/${missionId}/couverture`, body, modal)
// Liaison manuelle d'un ordre (Jordan 09.10) : même sélecteur, aperçu
// (`simuler`) puis application — mission choisie, ou fiche (suite /
// couverture).
export const lierOrdre = (ordreId, body) =>
	requete("post", `ordres/${ordreId}/lier`, body, modal)
